import React from "react";
import { connect } from "react-redux";
import * as actions from "../../../store/actions";
import { LocalStorageService } from "/services";

import { EstateTeaser } from "/components/estate-teaser/EstateTeaser";
import { EstateNavigationService } from "/services";
import Select from "react-select";

const getTeaserGridClass = () => {
    if (window.searchMaximumItemsInARow === 2) {
        return "mini-teaser-grid";
    }

    if (window.searchMaximumItemsInARow === 3) {
        return "small-teaser-grid";
    }

    return "teaser-grid";
};

const sortByPriceAscending = items => items.sort((a, b) => {
    if (b.displayPrice === false) {
        return -1;
    }

    return parseInt(a.priceForSorting) - parseInt(b.priceForSorting);
});

const sortByPriceDescending = items => items.sort((a, b) => {
    if (b.displayPrice === false) {
        return -1;
    }

    return parseInt(b.priceForSorting) - parseInt(a.priceForSorting);
});

const sortByDateAscending = items => items.sort((a, b) => {
    return Date.parse(a.putOnlineDateTime.date.substring(0, 10)) - Date.parse(b.putOnlineDateTime.date.substring(0, 10));
});

const sortByDateDescending = items => items.sort((a, b) => {
    return Date.parse(b.putOnlineDateTime.date.substring(0, 10)) - Date.parse(a.putOnlineDateTime.date.substring(0, 10));
});

const sortings = {
    PRICE_ASCENDING: {
        key: "PRICE_ASCENDING",
        label: "Prijs goedkoopste eerst",
        sort: sortByPriceAscending,
    },
    PRICE_DESCENDING: {
        key: "PRICE_DESCENDING",
        label: "Prijs duurste eerst",
        sort: sortByPriceDescending,
    },
    DATE_ASCENDING: {
        key: "DATE_ASCENDING",
        label: "Oudste eerst",
        sort: sortByDateAscending,
    },
    DATE_DESCENDING: {
        key: "DATE_DESCENDING",
        label: "Nieuwste eerst",
        sort: sortByDateDescending,
    },
};

const InternalEstateSearchResultsList = props => {
    const { showMap, setShowMap } = props;

    const sort = items => sortings[props.sorting].sort(items);

    const sortedEstates = sort(props.hits);

    const internalSetSorting = sorting => {
        props.setSorting(sorting);
        LocalStorageService.set("estate-search-sorting", sorting);
    };

    EstateNavigationService.setSearchResults(sortedEstates.map(estate => estate.url));

    const count = sortedEstates.length;

    const {
        showEstates,
        showProjects,
    } = window.estateOverview.filters;

    const results = (!showEstates && showProjects) ?
        count === 1 ? "project" : "projecten" :
        count === 1 ? "woning" : "woningen";

    return (
        <div className="estate-search-results">
            {sortedEstates.length === 0 && (
                <div className="estate-search-results__no-results">
                    <h2 className="headline-3">Sorry we vonden geen resultaten voor uw zoekopdracht.</h2>
                </div>
            )}
            {sortedEstates.length > 0 && (
                <React.Fragment>
                    <div className="estate-search-results__toolbar">
                        {window.pageType != 'referenties' && (
                            <div className="estate-search-results__actions">
                                <div className="ais-Stats">
                                    <span className="ais-Stats-text">
                                        <strong>{ count }</strong> {results}
                                    </span>
                                </div>
                                <div className="estate-search-results__sort">
                                    <span className="estate-search-results__sort-label">
                                        Sorteer op:
                                    </span>
                                    <Select
                                        className="react-select"
                                        classNamePrefix="react-select"
                                        options={Object.values(sortings)}
                                        getOptionLabel={option => option.label}
                                        getOptionValue={option => option.key}
                                        value={sortings[props.sorting]}
                                        isSearchable={false}
                                        onChange={(option) => { internalSetSorting(option.key); }}
                                        placeholder="Sorteer op"
                                    />
                                </div>
                            </div>
                        )}
                        <div className="estate-search-results__header">
                            <h1 className="estate-search-results__title headline-jumbo">
                                {window.pageType == 'referenties' && (
                                    <span className="ais-Stats-text">
                                        <strong>{ count }</strong>&nbsp;
                                    </span>
                                )}
                                {window.pageTitle}
                            </h1>
                            {window.estateOverview.allowMapView && (
                                <button className="estate-search__show-map" onClick={() => { setShowMap(!showMap); }}>
                                    <svg viewBox="0 0 13 18">
                                        <use xlinkHref="#svg-map-marker" />
                                    </svg>
                                    {showMap ? "Verberg kaart" : "Toon kaart"}
                                </button>
                            )}
                        </div>
                    </div>
                    {window.location.search == '?results=no' &&
                        <div className="estate-search-results__has-no-results">
                            <p>Sorry we vonden geen resultaten voor uw zoekopdracht.</p>
                        </div>
                    }
                    <div className="estate-search-results__results">
                        <div className={getTeaserGridClass()}>
                            {sortedEstates.map((estate, index) => {
                                let miniCTA;
                                if (index > 0 && index % 4 === 0) {
                                    miniCTA = window.miniCallToActions[(index / 4) - 1];
                                }

                                return (
                                    <React.Fragment key={`${showMap ? 'map' : 'nomap'}-${estate.id}`}>
                                        {miniCTA && (
                                            <div className="mini-call-to-action mini-call-to-action--estate-results">
                                                <div className="mini-call-to-action__inner">
                                                    <div className="mini-call-to-action__logo">
                                                        <svg viewBox="0 0 13 18">
                                                            <use xlinkHref="#svg-mini-logo" />
                                                        </svg>
                                                    </div>
                                                    <div className="mini-call-to-action__title headline-1">
                                                        {miniCTA.title}
                                                    </div>
                                                    <div className="mini-call-to-action__description">
                                                        {miniCTA.description}
                                                    </div>
                                                    <div className="mini-call-to-action__actions">
                                                        <a className="button" href={miniCTA.button.url}>
                                                            {miniCTA.button.text}
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                        <EstateTeaser estate={estate} />
                                    </React.Fragment>
                                );
                            })}
                        </div>
                    </div>
                </React.Fragment>
            )}
        </div>
    );
};

const mapStateToProps = state => {
    return {
        allEstates: state.categories.allEstates,
        sorting: state.filterValues.sorting,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        setSorting: sorting => dispatch(actions.setSorting(sorting)),
    };
};

const EstateSearchResultsList = connect(
    mapStateToProps,
    mapDispatchToProps,
)(InternalEstateSearchResultsList);

export { EstateSearchResultsList };
